"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HashSchema = void 0;
const zod_1 = require("zod");
/**
 * Схема для объекта-хеша (словаря)
 * Соответствует интерфейсу IHash из models
 */
const HashSchema = valueSchema => zod_1.z.record(zod_1.z.string(), valueSchema);
exports.HashSchema = HashSchema;
